// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1Uidj","title":"Images45_title__20ak_","images":"Images45_images__3V2eq"};